import { createContext } from '@chakra-ui/react-utils';
import { type SystemStyleObject } from '@chakra-ui/react-v2';

import type { DragSummaryPart } from './types';

export type DragSummaryStyles = Partial<
  Record<DragSummaryPart, SystemStyleObject>
>;

const [DragSummaryStylesProvider, useDragSummaryStyles] =
  createContext<DragSummaryStyles>({
    name: 'DragSummaryStylesContext',
    errorMessage:
      'useDragSummaryStyles: `context` is undefined. Seems you used a DragSummary sub-component that required a styles context outside of a DragSummary component.',
  });

export { DragSummaryStylesProvider, useDragSummaryStyles };
